import React from "react";
import {useParams} from "react-router-dom";
import {RouteWithId} from "../routes/types";
import LoadingIndicator from "../pages/LoadingIndicator";
import {AssetTitlingContent} from "./AssetTitlingContent";
import {useAssetTitling} from "./useAssetTitling";
import {calculateCNWInEstateTotalValue} from "../Assets/AssetSummary/common/AssetSummaryCalculator";
import AssetsViewContext from "../Assets/common/AssetsViewContext";
import {AssetAddEditSideDrawer} from "../Assets/common/AssetAddEditSideDrawer";
import DataEntrySideDrawerWrapper from "../components/DataEntrySideDrawerWrapper";
import useAnalytics from "../utils/useAnalytics";

export default function AssetTitling() {
    const {id} = useParams<RouteWithId>();

    useAnalytics(
        "Navigate_AssetTitlingPage",
        "Navigate_AssetTitlingPage_TimeSpent",
        "enableAssetTitlingGoogleAnalytics"
    );

    const {
        isLoading,
        assets,
        assetsTotal,
        approvedProfile,
        openDrawer,
        memberGroup,
        openHoldings,
        openOptionsAndGrant
    } = useAssetTitling(id);

    if (isLoading || !assets || !assetsTotal) {
        return <LoadingIndicator/>
    }


    return <AssetsViewContext.Provider value="AssetTitling">
        <AssetTitlingContent
            assets={assets}
            currentNetWorthAtDeath={calculateCNWInEstateTotalValue(assets, true)}
            approvedProfile={approvedProfile}
            isIncludedInDetailedReport={false}
            profileId={id}
        />
        <AssetAddEditSideDrawer
            open={openDrawer}
            profileId={id}
            clientAssets={assets}
            memberGroup={memberGroup!}
        />
        <DataEntrySideDrawerWrapper isOpen={openHoldings} type="holdings" viewType="AssetTitling" />
        <DataEntrySideDrawerWrapper isOpen={openOptionsAndGrant} type="optionsAndGrant" viewType="AssetTitling" />
    </AssetsViewContext.Provider>
}